export default "__VITE_ASSET__CpZVZnBx__"